"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _client = _interopRequireDefault(require("@sanity/client"));

var _loglevel = _interopRequireDefault(require("loglevel"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _objectSpread2(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Backend = {
  init: function init(services, options) {
    this.services = services; // this.options = Object.assign({}, options, this.options || {})

    if (!options.sanity) {
      throw new Error("This backend requires sanity options");
    }

    this.client = (0, _client["default"])(_objectSpread2({}, options.sanity, {}, options.useCdn === undefined && {
      useCdn: true
    }));
    var _options$sanity = options.sanity,
        _options$sanity$query = _options$sanity.query,
        query = _options$sanity$query === void 0 ? "*[_type == \"translations\" && (!defined(namespace) || namespace == $namespace)]{value, \"key\": i18nKey.current}" : _options$sanity$query,
        _options$sanity$param = _options$sanity.params,
        params = _options$sanity$param === void 0 ? {} : _options$sanity$param;
    this.query = query;

    _loglevel["default"].info("created");

    this.params = params;
  },
  readMulti: function readMulti(languages, namespaces, callback) {
    throw new Error("Not supported yet");
  },
  read: function read(language, namespace, callback) {
    this.getTranslations(language, namespace, callback);
  },
  getTranslations: function getTranslations(language, namespace, callback) {
    this.client.fetch(this.query, _objectSpread2({}, this.params, {
      namespace: namespace
    })).then(function (result) {
      var resources = result.reduce(function (acc, current) {
        acc[current.key] = current.value.map(function (item) {
          return item[language];
        });
        return acc;
      }, {});
      callback(null, resources);
    });
  },
  create: function create(languages, namespace, key, fallbackValue) {
    console.log("TODO:", "create new entry if missing", key);
    if (typeof languages === "string") languages = [languages];
    var payload = {};
    payload[key] = fallbackValue || "";
    languages.forEach(function (lng) {// let url = this.services.interpolator.interpolate(this.options.addPath, {
      //   lng: lng,
      //   ns: namespace
      // })
      // this.options.ajax(url, this.options, function(data, xhr) {
      //   //const statusCode = xhr.status.toString();
      //   // TODO: if statusCode === 4xx do log
      // }, payload);
    });
  }
};
Backend.type = "backend";
var _default = Backend;
exports["default"] = _default;